import { createAction, createAsyncActionTypes } from '@mews/framework';
import { RouteName } from '@mews-commander/enums';
import { CommanderThunkAction } from '@mews-commander/types';
import { createBackgroundAction, createPollerActions } from '@mews-commander/utils';
import { getSelectedServiceId } from '@mews-commander/legacy-entities/src/ducks/serviceSelect';
import { prefix } from '../module';
import { navigateInModal } from '../../app/actions/common';
import { isLoaded, getLastModified } from '../selectors/serviceStatistics';
import { shouldFetch } from './util';

export const SERVICE_STATISTICS_FETCH = prefix('SERVICE_STATISTICS_FETCH');
export const SERVICE_STATISTICS_RESET = prefix('SERVICE_STATISTICS_RESET');
export const [SERVICE_STATISTICS_FETCH_STARTED, SERVICE_STATISTICS_FETCH_SUCCEEDED, SERVICE_STATISTICS_FETCH_FAILED] =
    createAsyncActionTypes(SERVICE_STATISTICS_FETCH);

const SERVICE_STATISTICS_INTERVAL = 15 * 60 * 1000;

export const resetServiceStatistics = (): CommanderThunkAction => (dispatch) => {
    dispatch(createAction(SERVICE_STATISTICS_RESET));
    dispatch(destroyServiceStatisticsPoller());
};

const shouldFetchServiceStatistics = shouldFetch(isLoaded, getLastModified, SERVICE_STATISTICS_INTERVAL);
const fetchServiceStatistics =
    (serviceId: string): CommanderThunkAction =>
    async (dispatch, getState, { container, appClockService }) => {
        const { serviceComponent } = container();
        const state = getState();
        if (shouldFetchServiceStatistics(state, appClockService.getValue())) {
            const promise = serviceComponent.getOverviewStatistics(serviceId).then((stats: $TSFixMe) => ({
                ...stats,
                lastModified: appClockService.getValue(),
            }));
            return dispatch(createBackgroundAction(SERVICE_STATISTICS_FETCH, promise));
        }
    };

export const [startServiceStatisticsPoller, stopServiceStatisticsPoller, destroyServiceStatisticsPoller] =
    createPollerActions(fetchServiceStatistics, SERVICE_STATISTICS_INTERVAL);

export const navigateToReservationOverview =
    ({ mode }: { mode: 'Arrivals' | 'Departures' }): CommanderThunkAction =>
    (dispatch, getState, { resolveRoute }) => {
        const state = getState();
        const serviceId = getSelectedServiceId(state);
        const url = resolveRoute(RouteName.ReservationOverviewReportIndex, {
            query: { mode, 'Service.Id': serviceId },
        });
        dispatch(navigateInModal(url));
    };

export const navigateToReservationOverviewArrivals = (): CommanderThunkAction => (dispatch) =>
    dispatch(navigateToReservationOverview({ mode: 'Arrivals' }));

export const navigateToReservationOverviewDepartures = (): CommanderThunkAction => (dispatch) =>
    dispatch(navigateToReservationOverview({ mode: 'Departures' }));

export const navigateToCheckoutReport =
    (): CommanderThunkAction =>
    (dispatch, getState, { resolveRoute }) => {
        const serviceId = getSelectedServiceId(getState());
        const url = resolveRoute(RouteName.CheckoutReportIndex, { query: { 'Service.Id': serviceId } });
        dispatch(navigateInModal(url));
    };
